import { useEffect, useState } from "react";
import validateEmail from "@utils/validateEmail";

const EXCLUDED_EMAIL_PREFIXES = ["support+", "temp-user+"];
const EXCLUDED_EMAIL_DOMAINS = ["@noemail.internal"];

const isValidUserEmail = (email) => {
    if (!email) return false;
    if (EXCLUDED_EMAIL_DOMAINS.some((domain) => email.includes(domain))) return false;
    if (EXCLUDED_EMAIL_PREFIXES.some((prefix) => email.startsWith(prefix))) return false;
    return true;
};

const useContactDetails = ({ isBypassActive, promptUserForEmail, shouldShowDisplayName, user }) => {
    const [purchaseEmail, setPurchaseEmail] = useState("");
    const [emailError, setEmailError] = useState("");
    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");

    useEffect(() => {
        if (!isBypassActive || promptUserForEmail || !user) return;

        if (isValidUserEmail(user.email_address)) {
            setPurchaseEmail(user.email_address);
        }
        if (user.first_name) setFirstName(user.first_name);
        if (user.last_name) setLastName(user.last_name);
    }, [isBypassActive, promptUserForEmail, user]);

    const validateContactEmail = () => {
        if (!purchaseEmail || !validateEmail(purchaseEmail)) {
            setEmailError("Please enter a valid email address.");
            return false;
        }
        return true;
    };

    const isContactDetailsValid = !isBypassActive || (
        validateEmail(purchaseEmail) &&
        (!shouldShowDisplayName || (firstName.trim() !== "" && lastName.trim() !== ""))
    );

    return {
        purchaseEmail,
        setPurchaseEmail,
        firstName,
        setFirstName,
        lastName,
        setLastName,
        emailError,
        setEmailError,
        validateContactEmail,
        isContactDetailsValid,
    };
};

export default useContactDetails;
